import {
    apiRequest,
    rumpunList,
    rumpunActive,
    rumpunInactive
} from "../../../../../services/adapters/kepegawaian/rumpunService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", rumpunList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", rumpunInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", rumpunActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository